import createDOMSubscription from './createDOMSubscription';
import connectDOMNodes from './connectDOMNodes';

export default function render(renderer) {
  if (!renderer.updateSubscription) {
    connectDOMNodes(renderer);

    renderer.updateSubscription = createDOMSubscription(renderer.nodes);
    renderer.subscribe(renderer.updateSubscription);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-dom/es/dom/render.js
// module id = 112
// module chunks = 0